import Vue from "vue";
import Vuex from "vuex";
import { axiosInstance } from "@/plugins/axios-instance";
import cloneDeep from "clonedeep";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuOpen: false,
    isLoading: false,
    isDesktop: null,
    lang: ["pt-pt", "en"],
    langActive: "pt-pt",
    langActiveInput: "pt-pt",
    categories: [],
    templates: [],
    socialMedias: [],
    banners: [],
    templateSelected: {},
    productSelected: {},
    categoryEdited: {},
    categorySelected: {},
    productEdited: {},
    addressEdited: {},
    socialMediaEdited: {},
    userInfo: {},
    isChanges: {
      pending: false,
      website: false,
    },
    configSite: {
      uuid: sessionStorage.getItem("uuid") ?? "",
      website_url: "",
      name_site: "",
      template: null,
      is_preview: 0,
      legal_name: "",
      legal_address: "",
      nif: "",
      legal_email: "",
      legal_phones: "",
      colors: {
        primary_color: "",
        secondary_color: "",
      },
      logo: null,
      banner: {
        image: null,
        defaultBannerId: null,
        title: {
          "pt-pt": "",
          en: "",
        },
        subtitle: {
          "pt-pt": "",
          en: "",
        },
      },
      products: {
        is_active: 0,
        title: {
          "pt-pt": "",
          en: "",
        },
        subtitle: {
          "pt-pt": "",
          en: "",
        },
        product_items: [],
      },
      menu: {
        is_active: 0,
        isEmentaFile: 0,
        categories: [],
      },
      ementaFile: null,
      gallery: {
        is_active: 0,
        title: {
          "pt-pt": "",
          en: "",
        },
        subtitle: {
          "pt-pt": "",
          en: "",
        },
        pictures: [],
      },
      contacts: {
        title: {
          "pt-pt": "",
          en: "",
        },
        subtitle: {
          "pt-pt": "",
          en: "",
        },
        addresses: [],
      },
      social_media: {
        is_active: 0,
        social_media_items: [],
      },
      recruitment: {
        is_active: 0,
        description: {
          "pt-pt": "",
          en: "",
        },
        contact_email: "",
      },
      loyalty: {
        is_active: 0,
        title: {
          "pt-pt": "",
          en: "",
        },
        subtitle: {
          "pt-pt": "",
          en: "",
        },
      },
    },
  },
  getters: {
    menuOpen(state) {
      return state.menuOpen;
    },
    isLoading(state) {
      return state.isLoading;
    },
    isDesktop(state) {
      return state.isDesktop;
    },
    lang(state) {
      return state.lang;
    },
    langActive(state) {
      return localStorage.getItem("boost-locale") || state.langActive;
    },
    langActiveInput(state) {
      return (
        state.langActiveInput ||
        localStorage.getItem("boost-locale") ||
        state.langActive
      );
    },
    categories(state) {
      return state.categories;
    },
    templates(state) {
      return state.templates;
    },
    socialMedias(state) {
      return state.socialMedias;
    },
    banners(state) {
      return state.banners;
    },
    configSite(state) {
      return state.configSite;
    },
    templateSelected(state) {
      return state.templateSelected;
    },
    productSelected(state) {
      return state.productSelected;
    },
    categoryEdited(state) {
      return state.categoryEdited;
    },
    categorySelected(state) {
      return state.categorySelected;
    },
    productEdited(state) {
      return state.productEdited;
    },
    addressEdited(state) {
      return state.addressEdited;
    },
    socialMediaEdited(state) {
      return state.socialMediaEdited;
    },
    userInfo(state) {
      return state.userInfo;
    },
    isChanges(state) {
      return state.isChanges;
    },
  },
  mutations: {
    SET_MENU_OPEN(state, value) {
      state.menuOpen = value;
      document.body.classList.toggle("overflow-hidden");
    },
    SET_IS_LOADING(state, value) {
      state.isLoading = value;
    },
    SET_IS_DESKTOP(state, value) {
      state.isDesktop = value;
    },
    SET_LANG_ACTIVE(state, value) {
      state.langActive = value;
    },
    SET_LANG_ACTIVE_INPUT(state, value) {
      state.langActiveInput = value;
    },
    SET_CATEGORIES(state, value) {
      state.categories = value;
    },
    SET_TEMPLATES(state, value) {
      state.templates = value;
    },
    SET_SOCIAL_MEDIAS(state, value) {
      state.socialMedias = value;
    },
    SET_BANNERS(state, value) {
      state.banners = value;
    },
    SET_CONFIG_SITE(state, [key, value]) {
      if (!key) {
        state.configSite = value;
        return;
      }

      state.configSite[key] = value;
    },
    SET_TEMPLATE_SELECTED(state, value) {
      state.templateSelected = value;
    },
    SET_PRODUCT_SELECTED(state, value) {
      state.productSelected = value;
    },
    SET_CATEGORY_EDITED(state, value) {
      state.categoryEdited = value;
    },
    SET_CATEGORY_SELECTED(state, value) {
      state.categorySelected = value;
    },
    SET_PRODUCT_EDITED(state, value) {
      state.productEdited = value;
    },
    SET_ADDRESS_EDITED(state, value) {
      state.addressEdited = value;
    },
    SET_SOCIAL_MEDIA_EDITED(state, value) {
      state.socialMediaEdited = value;
    },
    SET_USER_INFO(state, value) {
      state.userInfo = value;
    },
    SET_IS_CHANGES(state, value) {
      state.isChanges = value;
    },
  },
  actions: {
    setIsLoading(context, value) {
      context.commit("SET_IS_LOADING", value);
    },
    setMenuOpen(context, value) {
      context.commit("SET_MENU_OPEN", value);
    },
    setLangActive(context, value) {
      localStorage.setItem("boost-locale", value);
      context.commit("SET_LANG_ACTIVE", value);
    },
    setLangActiveInput(context, value) {
      context.commit("SET_LANG_ACTIVE_INPUT", value);
    },
    setCategories(context, value) {
      context.commit("SET_CATEGORIES", value);
    },
    setConfigSite(context, [key, value]) {
      if (!key) {
        context.commit("SET_CONFIG_SITE", [null, value]);
        return;
      }

      context.commit("SET_CONFIG_SITE", [key, value]);
    },
    setTemplateSelected(context, value) {
      context.commit("SET_TEMPLATE_SELECTED", value);
    },
    setBanners(context, value) {
      context.commit("SET_BANNERS", value);
    },
    setProductSelected(context, value) {
      context.commit("SET_PRODUCT_SELECTED", value);
    },
    setCategoryEdited(context, value) {
      context.commit("SET_CATEGORY_EDITED", value);
    },
    setCategorySelected(context, value) {
      context.commit("SET_CATEGORY_SELECTED", value);
    },
    setProductEdited(context, value) {
      context.commit("SET_PRODUCT_EDITED", value);
    },
    setAddressEdited(context, value) {
      context.commit("SET_ADDRESS_EDITED", value);
    },
    setSocialMediaEdited(context, value) {
      context.commit("SET_SOCIAL_MEDIA_EDITED", value);
    },
    setUserInfo(context, value) {
      context.commit("SET_USER_INFO", value);
    },
    async getDataTemplates(context) {
      const langActive = context.getters.langActive;

      const { data } = await axiosInstance({
        method: "GET",
        url: `builder-template/${langActive}`,
      });

      context.commit("SET_TEMPLATES", data?.data);
    },
    async getDataSocialMedias(context) {
      const langActive = context.getters.langActive;

      const { data } = await axiosInstance({
        method: "GET",
        url: `builder-socialmedia-types/${langActive}`,
      });

      context.commit("SET_SOCIAL_MEDIAS", data?.data);
    },
    async getBanners(context) {
      const langActive = context.getters.langActive;

      const { data } = await axiosInstance({
        method: "GET",
        url: `builder-default-banners/${langActive}`,
      });

      context.commit("SET_BANNERS", data?.data);
    },
    async getChanges(context, userUuid) {
      const langActive = context.getters.langActive;

      const { data } = await axiosInstance({
        method: "GET",
        url: `builder-pending-changes/${userUuid}/${langActive}`,
      });

      context.commit("SET_IS_CHANGES", data?.data);
    },
    async getConfigSite(context, userUuid) {
      const langActive = context.getters.langActive;

      const { data } = await axiosInstance({
        method: "GET",
        url: `builder-website/${userUuid}/${langActive}`,
      });

      context.dispatch("setConfigSite", [null, data.data]);
    },
    async saveConfigSite(context) {
      const langActive = context.getters.langActive;
      const configSite = cloneDeep(context.getters.configSite);
      const arrayKeysHasImages = [
        "logo",
        "banner",
        "products",
        "gallery",
        "ementaFile",
      ];
      const formData = new FormData();

      context.dispatch("replaceUndefinedWithNull", configSite);

      Object.entries(configSite).map(([key, value]) => {
        // criando novos campos no formulário de acordo com as imagens dos elementos
        if (arrayKeysHasImages.includes(key)) {
          if (key === "logo" && value?.file) {
            formData.append(key, value.file);
          }

          if (key === "banner" && value?.image?.file) {
            delete value?.image?.url;
            formData.append(`bannerImage`, value?.image?.file);
          }

          if (
            key === "products" &&
            Array.isArray(configSite[key]?.product_items) &&
            configSite[key]?.product_items.length > 0
          ) {
            const arrayProductsImages = configSite[key]?.product_items?.filter(
              (item) => item?.image?.file
            );

            arrayProductsImages.forEach((element) => {
              delete element.image.url;
              formData.append(
                `productsImages-${element.id}`,
                element.image.file
              );
            });
          }

          if (
            key === "gallery" &&
            Array.isArray(configSite[key]?.pictures) &&
            configSite[key]?.pictures.length > 0
          ) {
            const arrayGalleryPictures = configSite[key]?.pictures?.filter(
              (item) => item?.picture && item.picture instanceof File
            );

            arrayGalleryPictures.forEach((element) => {
              delete element.url;
              formData.append(`galleryImages-${element.id}`, element.picture);
            });
          }

          if (
            key === "ementaFile" &&
            configSite?.menu?.isEmentaFile &&
            value instanceof File
          ) {
            formData.append(`ementaFile`, value);
          }

          // adicionando a condicional para evitar que envie a mesma chave 2 vezes
          if (!formData.has(key)) {
            formData.append(key, JSON.stringify(value));
          }
        } else {
          formData.append(key, JSON.stringify(value));
        }
      });

      // add language in payload formData
      formData.append("lang", langActive);

      return await axiosInstance({
        method: "POST",
        url: "builder-save-website",
        data: formData,
      });
    },
    replaceUndefinedWithNull(context, obj) {
      if (obj && typeof obj === "object") {
        Object.keys(obj).forEach((key) => {
          if (obj[key] === undefined) {
            obj[key] = null;
          } else {
            context.dispatch("replaceUndefinedWithNull", obj[key]);
          }
        });
      }
    },
    async sendLeads(context, formData) {
      return await axiosInstance({
        method: "POST",
        url: "builder-leads",
        data: formData,
      });
    },
    async handleLogin() {
      window.location.href = "/api/v1/salesforce/authorize";
    },
    async handleCallback() {
      const urlParams = new URLSearchParams(window.location.search);
      const access_token = urlParams.get("access_token");

      await axiosInstance({
        method: "GET",
        url: `/api/v1/salesforce/callback?access_token=${access_token}`,
      });
    },
    async handleLogout() {
      try {
        const { data } = await axiosInstance.get("salesforce/logout");

        return data;
      } catch (error) {
        console.error("Erro ao fazer logout:", error);
        throw error;
      }
    },
    async getUserInfo(context, uuid) {
      const langActive = context.getters.langActive;

      const { data } = await axiosInstance({
        method: "GET",
        url: `builder-userinfo/${uuid}/${langActive}`,
      });

      context.dispatch("setUserInfo", data?.data);
    },
  },
  modules: {},
});
